import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    sidebarShow: undefined,
    sidebarMinimize: false,
    classesFilterData: {},
  }),
  actions: {
    toggleSidebarDesktop() {
      this.sidebarShow = this.sidebarShow === false ? true : false
    },
    toggleSidebarMobile() {
      this.sidebarShow = this.sidebarShow === true ? false : true
    },
    set(variable, value) {
      this[variable] = value
    },
  },
})
